import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="w-full bg-navy px-5 py-20 text-center sm:py-24" data-id="element-86" data-mp="3ucndvrnypfti">
      <div className="mx-auto max-w-3xl" data-id="element-87" data-mp="3uei33i69nu3e">
        <h2 className="text-[28px] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-88" data-mp="c70yncel7jpm">
          Pronto/a a Portare la Musica in Ogni Classe?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-89" data-mp="m4ym3xomhch6">
          Unisciti agli insegnanti che hanno già trasformato le loro lezioni di musica con Musica
          Pronta.
        </p>
        <div className="mt-9" data-id="element-90" data-mp="vv1bzp0g6aba">
          <CTAButton data-id="element-91" data-mp="vu8e7djguv5a" />
          <p className="mt-5 text-sm text-white/70" data-id="element-92" data-mp="vwuhv238kqi8">
            Accesso immediato · Pronto da stampare · Garanzia 30 giorni
          </p>
        </div>
      </div>
    </section>;
}